import { DisplayMode } from './displayContext'

export const parseDisplayMode = (mode: string): DisplayMode => {
  if (mode.toUpperCase() === 'MAP') {
    return 'MAP'
  }

  return 'LIST'
}
